export default __webpack_public_path__ + "static/productdiscovery_old-cd840f3513c3ffecfc97fbd1c2c23b6e.jpg";